<template>

  <div>

    <div class="project-intro">
      <div class="preview">
        <img src="../../assets/portfolio/mazer-screens.png" alt="Mazer">
      </div>
      <div class="intro-text">
        <p>
          <a href="http://mazertel.com/" target="blank">Mazer Telecom Advisors</a> 
          have built our company on a core commitment — to obtain maximum value 
          and optimal terms for their clients' businesses or assets... and they needed 
          their website to reflect the value they bring.
        </p>
        <ul>
          <!-- <li>Branding</li> -->
          <!-- <li>UX</li> -->
          <!-- <li>UI</li> -->
          <!-- <li>Product Design</li> -->
          <li>Front-End Development</li>
        </ul>
      </div>
    </div>
    <div class="case-study">
      <div class="browser bar">
        <img src="../../assets/portfolio/mazer-1.jpg" alt="Mazer">
      </div>
      <div class="browser">
        <img src="../../assets/portfolio/mazer-scene-1.jpg" alt="Mazer">
      </div>
      <div class="browser bar">
        <img src="../../assets/portfolio/mazer-2.jpg" alt="Mazer">
      </div>
      <div class="browser bar">
        <img src="../../assets/portfolio/mazer-3.jpg" alt="Mazer">
      </div>
      <div class="browser">
        <img src="../../assets/portfolio/mazer-tablet-and-mobile.jpg" alt="Mazer">
      </div>
      <!-- <div class="browser bar">
        <img src="../../assets/portfolio/mazer-5.png" alt="Mazer">
      </div> -->
    </div>

    <div class="project-outro">
      <div class="outro-text">
        <h2>Bringing a design to life</h2>
        <p>
          Even though I love designing, one of my favorite things to do is 
          bring a design to life. When I received Mazer's PSD files from 
          our designer, I was excited by the challenge. 
          Becoming Dr. Frankenstein, by taking a lifeless image and using my 
          coding prowess to breathe life into it, never gets old!
        </p>
        <p style="font-size: 1.3rem; color: grey;">
          Developed while working at <a href="https://asenka.com/" target="blank">Asenka Interactive</a>.
        </p>
      </div>
      <div class="outro-img">
        <img src="../../assets/portfolio/frankenstein.jpg" alt="frankenstein">
      </div>
    </div>

  </div>


  </div>

</template>

<script>
export default {
  name: "mazer",
  props: ["title", "subtitle", "hero"]
};
</script>

<style scoped lang="scss">
</style>
